import SidebarNav from 'components/SidebarNav';
import Breadcrumb from 'components/Nav/Breadcrumb';
import styles from 'styles/modules/SidebarLayout.module.scss';

// breadcrumb={false}: the page renders its own trail.
export default function SidebarLayout({
    isAuthenticated,
    breadcrumb = true,
    children,
}) {
    return (
        <div
            className={[
                styles.layout,
                !isAuthenticated ? styles.lightBackground : '',
            ].join(' ')}
        >
            <div className={['container', styles.container].join(' ')}>
                <div className={['row', styles.row].join(' ')}>
                    {isAuthenticated && <SidebarNav />}

                    <div className={['page', styles.body].join(' ')}>
                        {isAuthenticated && breadcrumb && <Breadcrumb />}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
